import { Paper, Box, Typography } from '@mui/material';
import { tokens } from '../../theme/theme';

export default function StatCard({ label, value, delta, deltaGood = true, icon: Icon, accent }) {
  return (
    <Paper sx={{ p: 2.2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
          {label}
        </Typography>
        {Icon && <Icon fontSize="small" sx={{ color: accent || tokens.brand.main }} />}
      </Box>
      <Typography variant="h4" sx={{ color: tokens.text.primary, fontSize: '1.8rem' }}>
        {value}
      </Typography>
      {delta !== undefined && (
        <Typography
          variant="caption"
          sx={{ color: deltaGood ? tokens.severity.low : tokens.severity.critical, fontFamily: '"JetBrains Mono", monospace' }}
        >
          {delta}
        </Typography>
      )}
    </Paper>
  );
}
